// Static text: who runs the service does not depend on who is asking. The
// client half still ships, so the header can offer the cabinet to a visitor
// who is already signed in, the way it does on every other marketing page.
export const prerender = true;
